import {RestService} from "@/services/rest/RestService";
import {PopupTriggerEndpointsApi} from "@/api/pharma-cms-popup";
import {
    PopupCodeTriggerRestDto,
    PopupTimeDelayTriggerRestDto,
    PopupTriggerOverviewResultsRestDto
} from "@/api/pharma-cms-popup/models";
import {CacheService} from "@/services/cache/CacheService";
import {CacheKeyEnum} from "@/services/cache/CacheKeyEnum";

export class PopupTriggerRestService extends RestService {

    private apiService: PopupTriggerEndpointsApi;


    protected constructor() {
        super();
        this.apiService = new PopupTriggerEndpointsApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cmsUrl);
    }

    public async getTriggers(popupId: string): Promise<PopupTriggerOverviewResultsRestDto> {
        const response = await this.apiService.getPopupTriggerOverview(popupId);
        return response.data;
    }

    public async addPopupCodeTrigger(triggerRestDto: PopupCodeTriggerRestDto, popupId: string): Promise<void> {
        await this.apiService.createPopupCodeTrigger(triggerRestDto, popupId);
    }

    public async addPopupTimeDelayTrigger(triggerRestDto: PopupTimeDelayTriggerRestDto, popupId: string): Promise<void> {
        await this.apiService.createPopupTimeDelayTrigger(triggerRestDto, popupId);
    }

    public async addPopupExitIntentTrigger(popupId: string): Promise<void> {
        await this.apiService.createExitIntentDelayTrigger(popupId);
    }

    public async getPopupCodeTrigger(triggerId: string): Promise<PopupCodeTriggerRestDto> {
        const cacheKey = CacheKeyEnum.POPUP_CODE_TRIGGER + '_' + triggerId;
        let result: PopupCodeTriggerRestDto | undefined = CacheService.getInstance().get(cacheKey);
        if (result) {
            return result;
        }

        const response = await this.apiService.getPopupCodeTrigger(triggerId);
        result = response.data;

        CacheService.getInstance().set(cacheKey, result);
        return result;
    }

    public async getPopupTimeDelayTrigger(triggerId: string): Promise<PopupTimeDelayTriggerRestDto> {
        const cacheKey = CacheKeyEnum.POPUP_TIME_DELAY_TRIGGER + '_' + triggerId;
        let result: PopupTimeDelayTriggerRestDto | undefined = CacheService.getInstance().get(cacheKey);
        if (result) {
            return result;
        }

        const response = await this.apiService.getPopupTimeDelayTrigger(triggerId);
        result = response.data;

        CacheService.getInstance().set(cacheKey, result);
        return result;
    }

    public async updatePopupCodeTrigger(triggerId: string, trigger: PopupCodeTriggerRestDto): Promise<void> {
        await this.apiService.updatePopupCodeTrigger(trigger, triggerId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP_CODE_TRIGGER + '_' + triggerId);
    }

    public async updatePopupTimeDelayTrigger(triggerId: string, trigger: PopupTimeDelayTriggerRestDto): Promise<void> {
        await this.apiService.updatePopupTimeDelayTrigger(trigger, triggerId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP_TIME_DELAY_TRIGGER + '_' + triggerId);
    }

    public async deletePopupCodeTrigger(triggerId: string): Promise<void> {
        await this.apiService.deletePopupCodeTrigger(triggerId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP_CODE_TRIGGER + '_' + triggerId);
    }

    public async deletePopupTimeDelayTrigger(triggerId: string): Promise<void> {
        await this.apiService.deletePopupTimeDelayTrigger(triggerId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP_TIME_DELAY_TRIGGER + '_' + triggerId);
    }

    public async deletePopupExitIntentTrigger(popupId: string): Promise<void> {
        await this.apiService.deletePopupExitIntentTrigger(popupId);
    }
}
